import { action } from 'satcheljs/lib/legacy';
var updateDocking = action('updateDocking')(function updateDocking(dockingViewState, isTopDocking, isBottomDocking, scrollLeft, scrollBarHeight, dockingWidth, bottomDockingBottom) {
    dockingViewState.isTopDocking = isTopDocking;
    dockingViewState.isBottomDocking = isBottomDocking;
    dockingViewState.dockingWidth = dockingWidth;
    dockingViewState.scrollLeft = scrollLeft;
    dockingViewState.scrollBarHeight = scrollBarHeight;
    dockingViewState.bottomDockingBottom = bottomDockingBottom;
});
export var updateStickyDocking = action('updateStickyDocking')(function updateStickyDocking(dockingViewState, isBottomDocking) {
    dockingViewState.isBottomDocking = isBottomDocking;
});
export { updateDocking };
export default function calculateDocking(dockingViewState, scrollContainerScrollTop, scrollContainerScrollLeft, scrollContainerClientHeight, scrollContainerOffsetHeight, scrollBodyOffsetTop, scrollBodyOffsetHeight, composeBodyWidth) {
    var isTopDocking = scrollBodyOffsetTop <= scrollContainerScrollTop + dockingViewState.topDockingHeight &&
        scrollBodyOffsetTop +
            scrollBodyOffsetHeight -
            scrollContainerScrollTop -
            dockingViewState.topDockingHeight >
            dockingViewState.minBodyHeight;
    var isBottomDocking = scrollBodyOffsetTop + scrollBodyOffsetHeight >=
        scrollContainerScrollTop +
            scrollContainerClientHeight -
            dockingViewState.bottomDockingHeight;
    var bottomDockingBottom = Math.min(scrollContainerScrollTop +
        scrollContainerClientHeight -
        scrollBodyOffsetTop -
        dockingViewState.bottomDockingHeight -
        dockingViewState.minBodyHeight, 0);
    var scrollBarHeight = scrollContainerOffsetHeight - scrollContainerClientHeight;
    if (isTopDocking != dockingViewState.isTopDocking ||
        isBottomDocking != dockingViewState.isBottomDocking ||
        composeBodyWidth != dockingViewState.dockingWidth ||
        scrollContainerScrollLeft != dockingViewState.scrollLeft ||
        scrollBarHeight != dockingViewState.scrollBarHeight ||
        bottomDockingBottom != dockingViewState.bottomDockingBottom) {
        updateDocking(dockingViewState, isTopDocking, isBottomDocking, scrollContainerScrollLeft, scrollBarHeight, composeBodyWidth, bottomDockingBottom);
    }
}
//# sourceMappingURL=calculateDocking.js.map